var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 187,
    viewBox: "0 0 232 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.244 0H11.0815V52.637H220.244V0Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.778 12.4668H73.4148V15.2372H207.778V12.4668Z",
    fill: "#DBDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.778 22.1621H73.4148V24.9325H207.778V22.1621Z",
    fill: "#DBDBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.844 27.7031H73.4148V30.4735H182.844V27.7031Z",
    fill: "#DBDBDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.83 33.2441H73.4148V36.0145H146.83V33.2441Z",
    fill: "#DBDBDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.844 37.4004H73.4148V40.1708H182.844V37.4004Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.244 134.363H11.0815V187H220.244V134.363Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.778 146.83H73.4148V149.6H207.778V146.83Z",
    fill: "#DBDBDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.778 156.525H73.4148V159.296H207.778V156.525Z",
    fill: "#DBDBDB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.844 162.066H73.4148V164.837H182.844V162.066Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.83 167.607H73.4148V168.993H146.83V167.607Z",
    fill: "#DBDBDB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.844 171.764H73.4148V174.534H182.844V171.764Z",
    fill: "#DBDBDB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.785 65.1035H4.15552V121.896H225.785V65.1035Z",
    fill: "#FFC727"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231.326 126.051H0V60.9473H231.326V126.051ZM1.38204 124.685H229.944V62.313H1.38204V124.685Z",
    fill: "#FFC727"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0925 73.4141C27.0055 73.4141 18.0073 82.4122 18.0073 93.4992C18.0073 104.586 27.0055 113.584 38.0925 113.584C49.1795 113.584 58.1777 104.586 58.1777 93.4992C58.1777 82.4122 49.1795 73.4141 38.0925 73.4141ZM38.0925 109.567C29.2349 109.567 22.0244 102.357 22.0244 93.4992C22.0244 84.6417 29.2349 77.4311 38.0925 77.4311C46.9501 77.4311 54.1607 84.6417 54.1607 93.4992C54.1607 102.357 46.9501 109.567 38.0925 109.567Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3117 84.6211L34.0756 97.8572L28.8735 92.6753L26.0415 95.5073L34.0756 103.541L50.1437 87.4732L47.3117 84.6211Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5555 8.30859C31.6154 8.30859 23.5481 16.3759 23.5481 26.316C23.5481 36.2561 31.6154 44.3234 41.5555 44.3234C51.4956 44.3234 59.5629 36.2561 59.5629 26.316C59.5629 16.3759 51.4956 8.30859 41.5555 8.30859ZM41.5555 40.7219C33.6142 40.7219 27.1496 34.2573 27.1496 26.316C27.1496 18.3747 33.6142 11.9101 41.5555 11.9101C49.4968 11.9101 55.9614 18.3747 55.9614 26.316C55.9614 34.2573 49.4968 40.7219 41.5555 40.7219Z",
    fill: "#DBDBDB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8206 18.3574L37.9537 30.2243L33.2898 25.5784L30.7507 28.1174L37.9537 35.3204L52.3596 20.9145L49.8206 18.3574Z",
    fill: "#DBDBDB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5555 142.67C31.6154 142.67 23.5481 150.737 23.5481 160.677C23.5481 170.617 31.6154 178.685 41.5555 178.685C51.4956 178.685 59.5629 170.617 59.5629 160.677C59.5629 150.737 51.4956 142.67 41.5555 142.67ZM41.5555 175.083C33.6142 175.083 27.1496 168.619 27.1496 160.677C27.1496 152.736 33.6142 146.271 41.5555 146.271C49.4968 146.271 55.9614 152.736 55.9614 160.677C55.9614 168.619 49.4968 175.083 41.5555 175.083Z",
    fill: "#DBDBDB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8206 152.719L37.9537 164.586L33.2898 159.94L30.7507 162.479L37.9537 169.682L52.3596 155.276L49.8206 152.719Z",
    fill: "#DBDBDB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M213.319 78.9551H70.6445V81.7254H213.319V78.9551Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M213.319 88.6523H70.6445V91.4227H213.319V88.6523Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M187 94.1934H70.6445V96.9637H187V94.1934Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M148.215 99.7324H70.6445V102.503H148.215V99.7324Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187 105.273H70.6445V108.044H187V105.273Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.e8cb4932ed154ec53adae36757384a8d.svg";
export { ForwardRef as ReactComponent };